module.exports = __webpack_public_path__ + "static/slide2@2x-024e0187230519c071a48813e4bf95ac.png";